export class CommonPaths {
  static NotFound = '/404';
}
